import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

class NotFound extends Component {
  render() {
    return (
      <main style={{ maxWidth: 600, padding: 15, marginLeft: 'auto', marginRight: 'auto', color: '#fff' }}>
        <Helmet>
          <title>404 Not Found</title>
        </Helmet>
        <h1 style={{ fontWeight: 'normal', textAlign: 'center' }}>404 NotFound</h1>
        <p>お探しのページは見つかりませんでした。</p>
        <p>URLが間違っているか、既に削除されたURLです。</p>
        <p style={{ textAlign: 'center' }}><Link to='/'>トップページへもどる</Link></p>
      </main>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/common/NotFound.js